import BaseAPIService from '../base/base-api-service';
import PartClaimModel from 'src/model/partClaim.model';
import env from 'src/shared/env';

export interface IPartClaimCanada {
  accountNumber: string;
  companyName: string;
  customerAddress: string;
  customerCity: string;
  customerName: string;
  customerPhone: string;
  customerPostalCode: string;
  claimDate: string; // yyyy-mm-dd
  dateCall: string; // yyyy-mm-dd
  dateFailed: string; // yyyy-mm-dd
  defect: string;
  email: string;
  invoiceNumber: number;
  manufacturer: string;
  model: string;
  partNumber: string;
  price: number;
  purchaseDate: string; // yyyy-mm-dd
  quantity: number;
  serialNumber: string;
}

class PartClaimService extends BaseAPIService<PartClaimModel> {
  constructor() {
    super(PartClaimModel);
  }

  public createPartClaim(partClaimData: any) {
    const partClaimEndpoint = `${this.baseURL}accountapp/v1/warranty/claims`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getClaimNumber() {
    return new Promise((resolve, reject) => {
      const accountId = localStorage.getItem('activeAccount');
      const pathRetail = window.location.href;
      let claimNumberEndpoint;
      if (pathRetail.includes('retail')) {
        claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=retail&accountId=${accountId}`;
      } else {
        /* Claim always should create R number not P number */
        claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=retail&accountId=${accountId}`;
         /* If you want to create P number uncomment below line */
        // claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=defective&accountId=${accountId}`;
      }
      this.doRequest({
        method: 'get',
        url: claimNumberEndpoint
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public createPartClaimCanada(partClaimData: IPartClaimCanada) {
    const partClaimEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/canada`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getBrands() {
    const partClaimBrandEndpoint = `${this.baseURL}navapp/v1/brands`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'get',
        url: partClaimBrandEndpoint
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const PartClaimServiceInstance = new PartClaimService();
Object.freeze(PartClaimServiceInstance);

export default PartClaimServiceInstance;
